<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.service_chan{
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  width: -moz-fit-content;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  li{
    width: 190px;
    height: 188px;
    margin-right: 170px;
    background: url("../../assets/img/Virus/Virus/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p{
      font-size: 16px;
      color:#4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color:#959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/Virus/Virus/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }
    .liaojie{
      color: #fff;
    }
  }
  li:last-child{
    margin-right: 0;
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.compose-type1{
  margin-top: 100px;
  padding-bottom: 50px;
  background: url("../../assets/img/Virus/Lentivirus/ys_bg.png") no-repeat;
  background-size: 100% 100%;
}
.required{
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
  margin-top:10px;
  line-height: 30px;
}
.desc{
  font-size: 16px;
}
.method-table {

  /deep/{
    th {
      color: #333!important;
      padding: 20px 0;
    }
    td {
      padding: 20px 10px;
    }
    span {
      word-break: break-word;
    }
    p {
      text-align: left;
      margin-bottom:5px;
      margin-top:5px;
    }
  } 

}
@media screen and (max-width: 640px) {
  .compose-type1{
    margin-top:30px;
    padding-bottom: 20px;
  }
}  


</style>

<template>
  <div class="wrap wrap-tec">
    <mobile-img imgAlt="慢病毒包装" url="images/Virus/Lentivirus/banner"></mobile-img>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container">
        <p class="desc" style="margin-bottom: 10px;color:#014492;font-weight:bold;">慢病毒包装</p>
        <p class="desc">
          慢病毒（Lentivirus）载体是以HIV-1为基础发展起来的基因递送载体，可以将外源基因或外源干扰序列有效地整合到宿主染色体上，从而达到持久性表达目的序列的效果。区别一般的逆转录病毒载体，它对分裂细胞和非分裂细胞均具有感染能力，常用于感染难转染的细胞，如原代细胞、神经元细胞、干细胞、不分化细胞、肝细胞、内皮细胞、肿瘤细胞等，转染效率近100%，是介导外源基因表达的强大工具，可在体内和体外实现过表达、基因沉默、基因编辑等多种应用，让基因功能研究变得更加便利。
        </p>
        <p class="desc mt20">
          擎科生物可提供从序列设计到病毒包装全流程服务。多种规格、多种病毒载体类型可供选择，免疫原性低，滴度高，表达时间长，可满足各种实验需求。
        </p>
      </div>
      <div class="container">
        <en-title title="包装系统" enTitle="Packaging System"></en-title>
        <div style="width:80%;margin:0 auto">
          <mobile-img imgAlt="慢病毒包装-包装系统" url="images/Virus/Lentivirus/packaging01"></mobile-img>
          <p class="tc mt10" style="margin-bottom:50px;">擎科生物使用二代三质粒系统，由包装质粒、包膜质粒和穿梭质粒组成。</p>
          <mobile-img imgAlt="慢病毒包装-包装系统" url="images/Virus/Lentivirus/packaging02"></mobile-img>
          <p class="tc mt20">慢病毒包装和感染原理图（以二代系统为例）</p>
        </div>
      </div>
      <div class="container">
        <en-title title="服务流程" enTitle="Service  Process"></en-title>
        <mobile-img imgAlt="慢病毒包装-服务流程" url="images/Virus/Lentivirus/process"></mobile-img>
      </div>
      <div class="compose-type1">
        <div class="container">
          <en-title title="服务优势" enTitle="Advantages"></en-title>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/Virus/Lentivirus/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <div class="mb20"><p style="font-weight:bold;">高滴度</p>高效慢病毒包装系统，滴度≥1 × 10⁸TU/mL</div>
                <div class="mb20"><p style="font-weight:bold;">高纯度</p>采用超速离心过滤，高纯度、低残留，可达in vivo级</div>
                <div class="mb20"><p style="font-weight:bold;">超快速</p>基因合成+病毒包装快至17天交付</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <div class="tables" >
          <el-table
            border
            class="method-table"
            height="680px"
            :span-method="tableSpanMethod"
            :data="tableData">
            <el-table-column
              prop="method1"
              width="150"
              label="产品大类">
            </el-table-column>
            <el-table-column
              prop="method2"
              width="180"
              label="产品名称">
            </el-table-column>
            <el-table-column
              width="230"
              prop="method3"
              label="规格">
              <template slot-scope="scope">
                <div v-html="scope.row.method3"></div>
              </template>
            </el-table-column>
            <el-table-column
              prop="method4"
              width="130"
              label="周期(自然日)">
            </el-table-column>
            <el-table-column
              prop="method5"
              width="130"
              label="目录价(元)">
            </el-table-column>
            <el-table-column
              prop="method6"
              width="428"
              label="备注">
              <template slot-scope="scope">
                <div v-html="scope.row.method6"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div style="margin-top: 30px;">备注：所以产品均免费提供1 mL对照慢病毒、完整实验及检测报告和使用说明书。</div> -->
      </div>
      <div class="container">
        <en-title title="案例展示" enTitle="Case"></en-title>
        <p class="tc mb30">将病毒稀释至统一滴度后，分别取10 μL病毒液按照1:10梯度稀释至10⁶倍。取100 μL稀释10倍和稀释10⁶倍的病毒感染293T细胞。感染72 h后随机选取一个视野拍照（放大倍数100×）。</p>
        <div style="width:80%;margin:0 auto">
          <mobile-img imgAlt="慢病毒包装-服务流程" url="images/Virus/Lentivirus/case"></mobile-img>
          <p class="tc mt20">293T感染不同病毒后的图片</p>
        </div>
      </div>
      <div class="container">
        <en-title title="客户文章" enTitle="Customer Article"></en-title>
        <p class="tl mb20">1.Tan ZY, Feng P, Feng LL, et al. Low‐dose exercise protects the heart against established myocardial infarction via IGF‐1‐upregulated CTRP9 in male mice[J]. MedComm, 2023;4:e411. </p>
        <p class="tl mb20">2.Liu TY, Hu CC, Han CY , et al. IGF2BP2 promotes colorectal cancer progression by upregulating the expression of TFRC and enhancing iron metabolism[J]. Biology Direct, 2023, 18(1).  </p>
        <p>更多文献信息请前往<a class="pointer" @click="jumpToResource">高分文献手册</a>获取。</p>
      </div>
      <div class="container">
          <new-consult type="service" :typeList="['serviceOnline','telePhone','download','email']"></new-consult>
      </div>
      <!-- <div class="container">
        <qk-consult type="Virus"/>
      </div> -->
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index';
import bread from "@/components/bread";
import EnTitle from '@/components/EnTitle';
import MobileImg from '@/components/MobileImg'
export default {
  components:{
    bread,
    EnTitle,
    MobileImg
  },
  data () {
    return {
      tableData:[
        {
          method1:'过表达慢病毒',
          method2:'过表达慢病毒包装(客户提供质粒）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'12-15天',
          method5:'3500',
          method6:`<p>1.客户自行提供质粒，我方进行病毒包装</p> 
                   <p>2.不保证病毒的过表达效果</p>  
                   <p>3.含阴性对照，对照我司的空载慢病毒</p>`,
        },
        {
          method1:'',
          method2:'过表达慢病毒包装',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'4550',
          method6:`<p>1.此周期和报价均包含质粒构建，但目的基因超过2kb需另行评估周期及报价</p> 
                   <p>2.转染效率达90%或药筛后阳性细胞＞90%的前提下，保证mRNA水平至少3倍过表达，不保证蛋白水平表达效果</p>  
                   <p>3.细胞中目的基因的本底表达过高，可能会导致慢病毒过表达效果不明显,无法保证过表达效果</p>  
                   <p>4.含阴性对照</p>`,
        },
        {
          method1:'',
          method2:'',
          method3:'滴度≥<span>5E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'6500',
          method6:``,
        },
        {
          method1:'',
          method2:'',
          method3:'滴度≥<span>1E+9TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'11000',
          method6:``,
        },
        {
          method1:'',
          method2:'过表达对照病毒',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'2000',
          method6:`<p>1.含有荧光不含目的基因的慢病毒，可用于阴性对照或成像</p> 
                   <p>2.含阴性对照</p>`,
        },
        {
          method1:'siRNA慢病毒',
          method2:'干扰慢病毒包装（单靶点）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'2150',
          method6:`<p>1.此周期和报价均包含质粒构建</p> 
                   <p>2.客户提供shRNA序列，请自行确定shRNA的有效性，我方不保证干扰效果</p> 
                   <p>3.含阴性对照</p>`,
        },
        {
          method1:'',
          method2:'',
          method3:'滴度≥<span>1E+9TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'7800',
          method6:``,
        },
        {
          method1:'',
          method2:'干扰慢病毒包装（三保一，公司不筛，发3个）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'5880',
          method6:`<p>1.此周期和报价均包含质粒构建</p> 
                   <p>2.客户提供基因ID，我方设计并构建3个干扰慢病毒，发货3个</p> 
                   <p>3.在客户转染效率达到90%或进行阳性细胞筛选的前提下，保证至少1个慢病毒在mRNA水平干扰效率可达70%</p> 
                   <p>4.目的基因的表达非常低的情况下，无法保证干扰效率</p> 
                   <p>5.含阴性对照</p>`,
        },
        {
          method1:'',
          method2:'干扰慢病毒包装（三保一，公司筛选，发1个）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'6500',
          method6:`<p>1.此周期和报价均包含质粒构建</p> 
                   <p>2.客户提供基因ID，我方设计并构建3个干扰慢病毒，发货1个</p> 
                   <p>3.我方会在人源或小鼠源工具细胞中进行干扰效果验证，筛选出mRNA水平干扰效率可达70%的慢病毒，最后发货1个</p> 
                   <p>4.在客户转染效率达到90%或进行阳性细胞筛选的前提下，保证该病毒在mRNA水平干扰效率可达70%</p> 
                   <p>5.目的基因的表达非常低的情况下，无法保证干扰效率</p> 
                   <p>6.含阴性对照</p>`,
        },
        {
          method1:'',
          method2:'干扰慢病毒包装（五保二，公司不筛，发5个）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'8000',
          method6:`<p>1.此周期和报价均包含质粒构建</p> 
                   <p>2.客户提供基因ID，我方设计并构建5个干扰慢病毒，发货5个</p> 
                   <p>3.在客户转染效率达到90%或进行阳性细胞筛选的前提下，保证至少2个慢病毒在mRNA水平干扰效率可达70%</p> 
                   <p>4.目的基因的表达非常低的情况下，无法保证干扰效率</p> 
                   <p>5.含阴性对照</p>`,
        },
        {
          method1:'',
          method2:'干扰慢病毒包装（五保二，公司筛选，发2个）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'9000',
          method6:`<p>1.此周期和报价均包含质粒构建</p> 
                   <p>2.客户提供基因ID，我方设计并构建5个干扰慢病毒，发货2个</p> 
                   <p>3.我方会在人源或小鼠源工具细胞中进行干扰效果验证，筛选出mRNA水平干扰效率可达70%的慢病毒，最后发货2个</p> 
                   <p>4.在客户转染效率达到90%或进行阳性细胞筛选的前提下，保证该病毒在mRNA水平干扰效率可达70%</p> 
                   <p>5.目的基因的表达非常低的情况下，无法保证干扰效率</p> 
                   <p>6.含阴性对照</p>`,
        },
        {
          method1:'',
          method2:'干扰对照病毒',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'1800',
          method6:`<p>含有荧光和shRNA NC序列的慢病毒，可用于阴性对照或成像</p>`,
        },
        {
          method1:'sgRNA慢病毒',
          method2:'敲除慢病毒包装（单靶点）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'2250',
          method6:`<p>1.此周期和报价均包含质粒构建</p> 
                   <p>2.客户提供sgRNA序列，请自行确定sgRNA的有效性，我方不保证敲除效果</p> 
                   <p>3.含阴性对照</p>`,
        },
        {
          method1:'',
          method2:'',
          method3:'滴度≥<span>1E+9TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'7800',
          method6:``,
        },
        {
          method1:'',
          method2:'敲除慢病毒包装（三保一）',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'6500',
          method6:`<p>1.周期和报价均包含质粒构建</p> 
                   <p>2.客户提供基因ID，我方设计并构建3个敲除慢病毒，发货3个</p> 
                   <p>3.保证至少1个sgRNA具有切割效果，建议客户使用Sanger测序鉴定切割效果</p> 
                   <p>4.不保证KO cell pool在蛋白水平的敲除效果，请挑取单克隆细胞后在蛋白水平进行KO单克隆细胞株筛选</p>`,
        },
        {
          method1:'',
          method2:'Cas9慢病毒',
          method3:'滴度≥<span>1E+8TU/mL</span>，体积1<span>mL</span>',
          method4:'17-25天',
          method5:'2000',
          method6:`<p>仅含Cas9的慢病毒</p>`,
        },
        
      ],
      currentType: -1,
      currentService: -1,
      types: [
        {name: '腺病毒包装', img: '2', ref: '/Virus/Adenovirus_packaging'},
        {name: '腺相关病毒包装', img: '3', ref: '/Virus/Adeno_associated_virus'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }){   
      let rowspan = 1
      let colspan = 1
      if (columnIndex === 0) {
        if( rowIndex >= 0 && rowIndex < 5 ){
          rowspan = row.method1 ? 5:0
          colspan = row.method1 ? 1:0
        }
        if( rowIndex >= 5 && rowIndex < 12 ){
          rowspan = row.method1 ? 7:0
          colspan = row.method1 ? 1:0
        }
        if( rowIndex >= 12 && rowIndex < 16 ){
          rowspan = row.method1 ? 4:0
          colspan = row.method1 ? 1:0
        }
      }
      if (columnIndex === 1 || columnIndex === 5) {
        if( [1,2,3].indexOf(rowIndex) >-1 ){
          rowspan = row.method2 ? 3:0
          colspan = row.method2 ? 1:0
        } 
        if( [5,6,12,13].indexOf(rowIndex) >-1 ){
          rowspan = row.method1 ? 2:0
          colspan = row.method1 ? 1:0
        }
      }

      return {
        rowspan: rowspan,
        colspan: colspan
      }
    },
    jumpToResource () {
      resourceColumns().then(res => {
        let params = {}
        for(let [index, item] of res.data.entries() ){
          if(item.isShow){
            if(item.name === "高分文献手册"){
              params = {
                index,
                id: item.id,
                name: item.name,
                to: '/resource'
              }
              this.$router.push({ name:"resource", path:"/resource" , params })
              return
            }
            params = {
              index,
              id: item.id,
              name: item.name,
              to: '/resource'
            } 
          } 
        }
        this.$router.push({ name:"resource", path:"/resource" , params })    
      })
    },
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/Virus/Lentivirus_packaging.vue